export const COOKIE_PREFIX = 'ai-assistance';
export const COOKIES_CHECKING_INTERVAL = 4000;

export const DEFAULT_COOKIE_DOMAIN = 'aitarget.com';

export const AUTH_BACKEND_ERROR_TYPES = <const>{
  USER_PASSWORD_EXPIRED_ERROR: 'UserPasswordExpiredError',
  INVALID_PASSWORD_ERROR: 'InvalidPasswordError',
  USER_NOT_FOUND_ERROR: 'UserNotFoundError'
};

export const PASSWORD_MAX_LENGTH = 255;

export const USERNAME_MAX_LENGTH = 180;

export const PASSWORD_REGEX = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z\d\w\W]{8,}$/;
